import React from 'react'
import PropTypes from 'prop-types'

const CumulusIcon = props => {
  return (
    <svg
      aria-hidden="true"
      className={`navigation-icon${props.active ? ' active' : ''}`}
      width="66"
      height="70"
      viewBox="0 0 73 78"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Cumulus</title>
      <g transform="translate(16.5 16.6) scale(1.6)">
        <path
          d="M1.97335 5.00514C4.15856 3.16605 7.19898 3.25501 9.27581 4.68828C12.2743 6.51152 14.7011 10.3335 18.5275 9.40807C19.841 9.09052 20.8861 8.27234 20.9274 7.2004C20.9588 6.39084 20.4568 5.63714 19.8379 5.20443C14.6794 1.59831 7.71644 6.6015 4.59735 11.4261C2.7394 14.2999 0.881791 18.6497 3.56383 21.4532C9.43909 27.0042 13.6714 17.6519 17.5429 14.294C20.1837 11.6133 24.5618 12.2667 24.9817 16.369C25.2974 20.7929 21.4763 25 17.1891 25C12.0718 25 8.79925 21.739 6.07281 18.9866C4.95433 17.8574 1.97055 14.1658 1.60344 13.6207C-0.39787 11.0772 -0.794355 7.33487 1.97335 5.00514ZM3.90508 8.13373C1.98768 10.6676 2.72611 14.6819 7.1745 19.0579C12.712 24.5056 19.7386 23.4154 21.5994 18.9549C22.7465 16.2048 20.0722 14.6643 17.9104 16.8986C16.1643 18.7028 14.3186 20.9005 11.9113 22.9092C9.36916 25.0307 4.29772 24.62 2.30585 21.2253C-1.26426 15.1419 6.64551 6.25844 12.2376 3.9563C15.1378 2.71921 19.7309 2.43166 22.1749 4.62277C23.6685 5.96227 24.1034 8.08822 22.8591 9.85146C21.3693 11.9622 18.309 12.1215 16.1416 10.9855C12.7015 9.34945 6.88151 4.20041 3.90508 8.13373Z"
          fill="#FFF"
        />
      </g>
    </svg>
  )
}

CumulusIcon.propTypes = {
  active: PropTypes.bool
}

export default CumulusIcon
